import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RightModel} from '../../app.rights';
import {TaskRecord} from '../../lib/task/task-record.service';
import {PaletteColorPickerComponent} from "../palette-color-picker/palette-color-picker.component";
import {Icon} from "../../lib/task/icon.service";
import {TaskRecordStateMachine} from "../../lib/task/task-record-statemachine";

@Component({
  selector: 'app-task-record-table-cell',
  templateUrl: './task-record-table-cell.component.html',
  styleUrls: ['./task-record-table-cell.component.scss']
})
export class TaskRecordTableCellComponent implements OnInit {

  @Input()
  set taskRecord(value: TaskRecord.TaskRecord) {
    this._taskRecord = value;
    this.updateData();
  }

  @Input()
  rightModel: RightModel = RightModel.empty();

  @Input()
  borderEnabled: boolean = false;

  @Output()
  taskRecordClicked: EventEmitter<number> = new EventEmitter<number>();

  _taskRecord?: TaskRecord.TaskRecord;
  _stateObject?: TaskRecordStateMachine.StateObject;
  _icon?: Icon.Icon;

  cellTitle: string = '';
  cellSubtitle: string = '';

  constructor() {
  }

  ngOnInit() {
  }

  private updateData() {
    if (this._taskRecord) {
      this.cellTitle = this._taskRecord.name;
      const subtitleParts: string[] = [];
      if (this._taskRecord.task?.name) {
        subtitleParts.push(this._taskRecord.task?.name);
      }
      if (this._taskRecord.externalId) {
        subtitleParts.push(this._taskRecord.externalId);
      }
      this.cellSubtitle = subtitleParts.join(" - ");
      if (this._taskRecord.state) {
        this._stateObject = TaskRecordStateMachine.taskRecordStates.get(this._taskRecord.state);
      }
      if (this._taskRecord.task) {
        this._icon = this._taskRecord.task.icon;
      }
    }
  }

  onTaskRecordClicked() {
    if (this._taskRecord) {
      this.taskRecordClicked.emit(this._taskRecord.taskRecordId);
    }
  }

  getColorIndex(): number {
    return this._taskRecord?.task ? this._taskRecord?.task.taskRecordColor : 0;
  }

  getColor() {
    return PaletteColorPickerComponent.resolveColor(this.getColorIndex());
  }

}
